<template>
  <NuxtLink
    v-if="person"
    class="min-w-[250px] max-w-[350px] bg-white p-4 rounded-lg flex-grow relative text-typo-primary"
    :to="
      localePath({
        name: 'professionalPage',
        params: {
          professionalSeoName: person.seoName,
        },
      })
    "
  >
    <div class="flex">
      <PersonPictureSet
        :person="person"
        :alt="person.name"
        class="rounded absolute top-[-0.5rem] overflow-hidden"
        :width="'70'"
        :height="'70'"
      />
      <div
        class="mb-2 text-right grow"
        :class="[
          {
            invisible: !hasNonZeroPrice,
          },
        ]"
      >
        <div class="text-xl font-extrabold text-teal-400">
          {{ $n(person?.price?.price ?? 0, "currency") }}
        </div>
        <div class="text-xs text-blog-primary">
          {{
            $t("swiperInset.unitPrice", {
              unitPrice: professionTask.unit,
            })
          }}
        </div>
      </div>
    </div>
    <div class="text-base font-bold">
      {{ person.name }}
    </div>
    <div class="mb-2 text-xs font-extrabold opacity-50">
      {{ person.city?.name }}
    </div>
    <div class="overflow-hidden text-sm font-semibold line-clamp-2">
      <template v-if="person?.price?.description">
        {{ person.price.description }}
      </template>
      <JoszakiHtmlTextBlock
        v-else-if="person.memoHtml"
        :text="person.memoHtml"
      />
      <template v-else>
        {{ person.memo?.slice(0, 500) }}
      </template>
    </div>
  </NuxtLink>
</template>

<script>
import PersonPictureSet from "~/components/PersonPictureSet.vue";
import JoszakiHtmlTextBlock from "~/components/_refactored/common/JoszakiHtmlTextBlock.vue";

export default {
  components: {
    PersonPictureSet,
    JoszakiHtmlTextBlock,
  },
  props: {
    professionTask: {
      type: Object,
      required: true,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasNonZeroPrice() {
      return this.person?.price?.price > 0;
    },
  },
};
</script>
